module.exports = __webpack_public_path__ + "static/media/product-feature-tile-icon-03.6b071ded.svg";